export default __webpack_public_path__ + "static/shipitCEO-1f2b7353-d6a8d7c26618107c6231df02b7993b2e.webp";